import { buildAppOpenTabShareUrl } from './appOpenTabShareUrl';
import { parseEntityShowResponse } from './entityShowResponse';

/** Mapovanie typu záznamu / tabu → detail OTK (cust003/005/007). */

export const OTK_ERROR_RECORD_TAB_BY_TYPE = Object.freeze({
  'Interná chyba': { page: 'InternaChyba', mask: 'qlty003', titleKey: 'Util.Tab.EditInternalError' },
  'Externá chyba': { page: 'ExternaChyba', mask: 'qlty005', titleKey: 'Util.Tab.EditExternalError' },
  'Reklamácia': { page: 'Reklamacia', mask: 'qlty007', titleKey: 'Util.Tab.EditComplaint' },
});

export const OTK_ERROR_RECORD_TAB_BY_PAGE = Object.freeze({
  InternaChyba: OTK_ERROR_RECORD_TAB_BY_TYPE['Interná chyba'],
  ExternaChyba: OTK_ERROR_RECORD_TAB_BY_TYPE['Externá chyba'],
  Reklamacia: OTK_ERROR_RECORD_TAB_BY_TYPE['Reklamácia'],
});

/** Hodnota `page` v notifikácii (NotificationTopic) → React page. */
export const OTK_ERROR_RECORD_PAGE_BY_TOPIC = Object.freeze({
  'otk.internal_errors': 'InternaChyba',
  'otk.external_errors': 'ExternaChyba',
  'otk.complaints': 'Reklamacia',
});

export function resolveOtkPageFromNotification(pageOrTopic) {
  const key = String(pageOrTopic ?? '').trim();
  if (OTK_ERROR_RECORD_TAB_BY_PAGE[key]) return key;
  return OTK_ERROR_RECORD_PAGE_BY_TOPIC[key] ?? null;
}

/**
 * @param {unknown} res odpoveď GET /api/error_records/{id}
 * @returns {object|null}
 */
export function parseErrorRecordShowResponse(res) {
  return parseEntityShowResponse(res);
}

/**
 * Preferuje skutočný typ záznamu; URL tab je len fallback.
 * @param {object} errorRecord
 * @param {string|null|undefined} preferredPage InternaChyba | ExternaChyba | Reklamacia
 */
export function resolveErrorRecordTab(errorRecord, preferredPage = null) {
  const byType = OTK_ERROR_RECORD_TAB_BY_TYPE[String(errorRecord?.type ?? '')];
  if (byType) return byType;
  const page = String(preferredPage ?? '').trim();
  return OTK_ERROR_RECORD_TAB_BY_PAGE[page] ?? null;
}

export function deepLinkWarnKeyForPage(page) {
  if (page === 'InternaChyba') return 'Util.DeepLink.Warn.InternalError';
  if (page === 'ExternaChyba') return 'Util.DeepLink.Warn.ExternalError';
  return 'Util.DeepLink.Warn.Complaint';
}

/** Odkaz na skopírovanie / email – aktuálna doména + štandardná cesta openTab. */
export function buildOtkErrorRecordShareUrl(page, errorRecordId) {
  const id = Number(errorRecordId);
  if (!Number.isFinite(id) || id <= 0) return '';
  return buildAppOpenTabShareUrl(page, { error_record_id: id });
}
